/* Layout */
import Layout from '@/views/iori/layout/Layout'

/**
 * 业务系统相关路由
 */
const businessRouter = [
    // SSO 账号管理
    {
        path: '/sso/account/manager',
        component: Layout,
        redirect: '/sso/account/manager/list',
        children: [
            {
                path: 'list',
                name: 'SsoUserManager',
                component: () => import('@/views/business/sso/account/manager/index')
            }
        ]
    },
    // 定时任务管理
    {
        path: '/clocky/job',
        component: Layout,
        redirect: '/clocky/job/list',
        children: [
            {
                path: 'list',
                name: 'JobManager',
                component: () => import('@/views/business/clocky/job/index')
            }
        ]
    },

    //设备清单
    {
        path: '/tenant/base/device',
        component: Layout,
        redirect: '/tenant/base/device/manager',
        children: [
            {
                path: 'manager',
                name: 'DeviceManager',
                component: () => import('@/views/business/base/device/tenant/index')
            },
            {
                path: 'isolate',
                name: 'DeviceIsolate',
                component: () => import('@/views/business/base/device/tenant/deviceIsolate')
            },
            {
                path: 'icon',
                name: 'DeviceIcon',
                component: () => import('@/views/business/base/device/tenant/deviceIcon')
            },
        ]
    },
    //位置管理
    {
        path: '/tenant/base/position',
        component: Layout,
        redirect: '/tenant/base/position/manager',
        children: [
            {
                path: 'manager',
                name: 'PositionManager',
                component: () => import('@/views/business/base/position/tenant/index')
            }
        ]
    },
    //系统分类管理
    {
        path: '/tenant/base/category',
        component: Layout,
        redirect: '/tenant/base/category/manager',
        children: [
            {
                path: 'manager',
                name: 'CategoryManager',
                component: () => import('@/views/business/base/category/tenant/index')
            }
        ]
    },
    //物料管理
    {
        path: '/tenant/base/materiel',
        component: Layout,
        redirect: '/tenant/base/materiel/manager',
        children: [
            {
                path: 'manager',
                name: 'MaterielManager',
                component: () => import('@/views/business/base/materiel/tenant/index')
            }
        ]
    },
    //物料分类管理
    {
        path: '/tenant/base/materielcategory',
        component: Layout,
        redirect: '/tenant/base/materielcategory/manager',
        children: [
            {
                path: 'manager',
                name: 'MaterielCategoryManager',
                component: () => import('@/views/business/base/materielcategory/tenant/index')
            }
        ]
    },
    //项目管理
    {
        path: '/tenant/project',
        component: Layout,
        redirect: '/tenant/project/list',
        children: [
            {
                path: 'list',
                name: 'projectManager',
                component: () => import('@/views/business/base/project/tenant/index')
            }
        ]
    },
    //控制源管理
    {
        path: '/tenant/controlsource',
        component: Layout,
        redirect: '/tenant/controlsource/list',
        children: [
            {
                path: 'list',
                name: 'controlSourceManager',
                component: () => import('@/views/business/base/controlsource/tenant/index')
            }
        ]
    },
    //地图管理
    {
        path: '/tenant/map',
        component: Layout,
        redirect: '/tenant/map/manager',
        children: [
            {
                path: 'manager',
                name: 'mapManager',
                component: () => import('@/views/business/base/map/tenant/manager')
            },
            {
                path: 'exhibition',
                name: 'mapExhibition',
                component: () => import('@/views/business/base/map/tenant/exhibition')
            }
        ]
    },
    {
        path: '/tenant/map/details',
        component: Layout,
        redirect: '/tenant/map/details/manager',
        children: [
            {
                path: 'manager',
                name: 'detailsManager',
                component: () => import('@/views/business/base/map/tenant/details/manager')
            },
        ]
    },
    //*******************************工单模块*************************************
    //工单设置
    {
        path: '/tenant/order/orderConfig',
        component: Layout,
        redirect: '/tenant/order/orderConfig/list',
        children: [
            {
                path: 'list',
                name: 'OrderConfig',
                component: () => import('@/views/business/order/orderConfig/tenant/orderConfig')
            }
        ]
    },
    //物料领用
    {
        path: '/tenant/order/orderQuery/materialDrawing',
        component: Layout,
        redirect: '/tenant/order/orderQuery/materialDrawing/list',
        children: [
            {
                path: 'list',
                name: 'materialDrawing',
                component: () => import('@/views/business/order/orderQuery/materialDrawing/tenant/index')
            }
        ]
    },
    //工单查询
    {
        path: '/tenant/order/orderQuery/order',
        component: Layout,
        redirect: '/tenant/order/orderQuery/order/list',
        children: [
            {
                path: 'list',
                name: 'orderManager',
                component: () => import('@/views/business/order/orderQuery/order/tenant/order')
            }
        ]
    },
    //工单统计
    {
        path: '/tenant/order/orderStatistics',
        component: Layout,
        redirect: '/tenant/order/orderStatistics/list',
        children: [
            {
                path: 'list',
                name: 'orderStatisticsManager',
                component: () => import('@/views/business/order/orderStatistics/tenant/orderStatistics')
            }
        ]
    },
    //*******************************巡检模块*************************************
    //巡检模版
    {
        path: '/tenant/inspection/template',
        component: Layout,
        redirect: '/tenant/inspection/template/manager',
        children: [
            {
                path: 'manager',
                name: 'InspectionTemplate',
                component: () => import('@/views/business/inspection/template/tenant/index')
            }
        ]
    },
    //巡检计划
    {
        path: '/tenant/inspection/plan',
        component: Layout,
        redirect: '/tenant/inspection/plan/manager',
        children: [
            {
                path: 'manager',
                name: 'InspectionPlan',
                component: () => import('@/views/business/inspection/plan/tenant/index')
            }
        ]
    },
    //巡检查询
    {
        path: '/tenant/inspection/inspectionSearch',
        component: Layout,
        redirect: '/tenant/inspection/inspectionSearch/list',
        children: [
            {
                path: 'list',
                name: 'inspectionSearchManager',
                component: () => import('@/views/business/inspection/query/tenant/inspectionQuery')
            }
        ]
    },
    //*******************************维保模块*************************************
    //维保模版
    {
        path: '/tenant/maintenance/template',
        component: Layout,
        redirect: '/tenant/maintenance/template/manager',
        children: [
            {
                path: 'manager',
                name: 'MaintenanceTemplate',
                component: () => import('@/views/business/maintenance/template/tenant/index')
            }
        ]
    },
    //维保计划
    {
        path: '/tenant/maintenance/plan',
        component: Layout,
        redirect: '/tenant/maintenance/plan/manager',
        children: [
            {
                path: 'manager',
                name: 'MaintenancePlan',
                component: () => import('@/views/business/maintenance/plan/tenant/index')
            }
        ]
    },
    //维保查询
    {
        path: '/tenant/maintenance/query',
        component: Layout,
        redirect: '/tenant/maintenance/query/manager',
        children: [
            {
                path: 'manager',
                name: 'MaintenanceQuery',
                component: () => import('@/views/business/maintenance/query/tenant/index')
            }
        ]
    },
    //IOT
    {
        path: '/iot',
        component: Layout,
        redirect: '/iot/real/alarm',
        children: [
            {
                path: 'mqtt/server',
                name: 'MqttServer',
                component: () => import('@/views/business/iot/mqtt/index')
            },
            {
                path: 'real/alarm',
                name: 'RealAlarm',
                component: () => import('@/views/business/iot/alarm/realAlarm')
            },
            {
                path: 'history/alarm',
                name: 'HistoryAlarm',
                component: () => import('@/views/business/iot/alarm/historyAlarm')
            },
            {
                path: 'history/point',
                name: 'HistoryPoint',
                component: () => import('@/views/business/iot/point/historyData')
            }
        ]
    },
    //租户首页
    {
        path: '/tenant/home',
        component: Layout,
        redirect: '/tenant/home',
        children: [
            {
                path: 'facilityHome/index',
                name: 'FacilityHome',
                component: () => import('@/views/business/home/facilityHome/tenant/index')
            },
        ]
    },
    {
        path: '/home',
        component: Layout,
        redirect: '/home/index',
        children: [
            {
                path: 'index',
                name: 'Home',
                component: () => import('@/views/business/home/index')
            },
        ]
    },
    //------------------------------------能耗管理---------------
    // 能耗量管理--level1
    {
        path: '/consumption/level1',
        component: Layout,
        redirect: '/consumption/level1/index',
        children: [
            {
                path: 'index',
                name: 'consumption',
                component: () => import('@/views/business/energy/consumption/level1/index')
            }
        ]
    },
    // 能耗量管理--level2-electric
    {
        path: '/consumption/level2/electric',
        component: Layout,
        redirect: '/consumption/level2/electric/index',
        children: [
            {
                path: 'index',
                name: 'electric',
                component: () => import('@/views/business/energy/consumption/level2/electric/index')
            }
        ]
    },
    // 能耗量管理--level2-water
    {
        path: '/consumption/level2/water',
        component: Layout,
        redirect: '/consumption/level2/water/index',
        children: [
            {
                path: 'index',
                name: 'water',
                component: () => import('@/views/business/energy/consumption/level2/water/index')
            }
        ]
    },
    // 能耗量管理--level3-aircondition
    {
        path: '/consumption/level3/aircondition',
        component: Layout,
        redirect: '/consumption/level3/aircondition/index',
        children: [
            {
                path: 'index',
                name: 'aircondition',
                component: () => import('@/views/business/energy/consumption/level3/aircondition/index')
            }
        ]
    },
    // 能耗量管理--level3-light
    {
        path: '/consumption/level3/light',
        component: Layout,
        redirect: '/consumption/level3/light/index',
        children: [
            {
                path: 'index',
                name: 'light',
                component: () => import('@/views/business/energy/consumption/level3/light/index')
            }
        ]
    },
    // 能耗量管理--level3-power
    {
        path: '/consumption/level3/power',
        component: Layout,
        redirect: '/consumption/level3/power/index',
        children: [
            {
                path: 'index',
                name: 'power',
                component: () => import('@/views/business/energy/consumption/level3/power/index')
            }
        ]
    },
    // 能耗量管理--level3-special
    {
        path: '/consumption/level3/special',
        component: Layout,
        redirect: '/consumption/level3/special/index',
        children: [
            {
                path: 'index',
                name: 'special',
                component: () => import('@/views/business/energy/consumption/level3/special/index')
            }
        ]
    },
    // 能源费--level1-energyfee
    {
        path: '/energyfee/level1',
        component: Layout,
        redirect: '/energyfee/level1/index',
        children: [
            {
                path: 'index',
                name: 'energyfee',
                component: () => import('@/views/business/energy/energyfee/level1/index')
            }
        ]
    },

    // 能源费--level2-power
    {
        path: '/energyfee/level2/power',
        component: Layout,
        redirect: '/energyfee/level2/power/index',
        children: [
            {
                path: 'index',
                name: 'power',
                component: () => import('@/views/business/energy/energyfee/level2/power/index')
            }
        ]
    },
    // 能源费--level2-water
    {
        path: '/energyfee/level2/water',
        component: Layout,
        redirect: '/energyfee/level2/water/index',
        children: [
            {
                path: 'index',
                name: 'water',
                component: () => import('@/views/business/energy/energyfee/level2/water/index')
            }
        ]
    },
    // 能源费--level2-gas
    {
        path: '/energyfee/level2/gas',
        component: Layout,
        redirect: '/energyfee/level2/gas/index',
        children: [
            {
                path: 'index',
                name: 'gas',
                component: () => import('@/views/business/energy/energyfee/level2/gas/index')
            }
        ]
    },
    // 能源费--level2-hot
    {
        path: '/energyfee/level2/hot',
        component: Layout,
        redirect: '/energyfee/level2/hot/index',
        children: [
            {
                path: 'index',
                name: 'hot',
                component: () => import('@/views/business/energy/energyfee/level2/hot/index')
            }
        ]
    },
    // 能源费--level2-others
    {
        path: '/energyfee/level2/others',
        component: Layout,
        redirect: '/energyfee/level2/others/index',
        children: [
            {
                path: 'index',
                name: 'others',
                component: () => import('@/views/business/energy/energyfee/level2/others/index')
            }
        ]
    },
    // 节能--level1-总目标
    {
        path: '/performanc/level1',
        component: Layout,
        redirect: '/performanc/level1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/performanc/level1/index')
            }
        ]
    },

    // 节能--level2-气
    {
        path: '/performanc/level2/gas',
        component: Layout,
        redirect: '/performanc/level2/gas/index',
        children: [
            {
                path: 'index',
                name: 'gas',
                component: () => import('@/views/business/energy/performanc/level2/gas/index')
            }
        ]
    },

    // 节能--level2-热
    {
        path: '/performanc/level2/hot',
        component: Layout,
        redirect: '/performanc/level2/hot/index',
        children: [
            {
                path: 'index',
                name: 'hot',
                component: () => import('@/views/business/energy/performanc/level2/hot/index')
            }
        ]
    },
    // 节能--level2-电
    {
        path: '/performanc/level2/power',
        component: Layout,
        redirect: '/performanc/level2/power/index',
        children: [
            {
                path: 'index',
                name: 'power',
                component: () => import('@/views/business/energy/performanc/level2/power/index')
            }
        ]
    },
    // 节能--level2-水
    {
        path: '/performanc/level2/water',
        component: Layout,
        redirect: '/performanc/level2/water/index',
        children: [
            {
                path: 'index',
                name: 'water',
                component: () => import('@/views/business/energy/performanc/level2/water/index')
            }
        ]
    },
    // 节能--level2-其他
    {
        path: '/performanc/level2/others',
        component: Layout,
        redirect: '/performanc/level2/others/index',
        children: [
            {
                path: 'index',
                name: 'others',
                component: () => import('@/views/business/energy/performanc/level2/others/index')
            }
        ]
    },
    // 定额--level1-总目标
    {
        path: '/quota/level1',
        component: Layout,
        redirect: '/quota/level1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/quota/level1/index')
            }
        ]
    },

    // 定额--level2-气
    {
        path: '/quota/level2/gas',
        component: Layout,
        redirect: '/quota/level2/gas/index',
        children: [
            {
                path: 'index',
                name: 'gas',
                component: () => import('@/views/business/energy/quota/level2/gas/index')
            }
        ]
    },

    // 定额--level2-热
    {
        path: '/quota/level2/hot',
        component: Layout,
        redirect: '/quota/level2/hot/index',
        children: [
            {
                path: 'index',
                name: 'hot',
                component: () => import('@/views/business/energy/quota/level2/hot/index')
            }
        ]
    },
    // 定额--level2-电
    {
        path: '/quota/level2/power',
        component: Layout,
        redirect: '/quota/level2/power/index',
        children: [
            {
                path: 'index',
                name: 'power',
                component: () => import('@/views/business/energy/quota/level2/power/index')
            }
        ]
    },
    // 定额--level2-水
    {
        path: '/quota/level2/water',
        component: Layout,
        redirect: '/quota/level2/water/index',
        children: [
            {
                path: 'index',
                name: 'water',
                component: () => import('@/views/business/energy/quota/level2/water/index')
            }
        ]
    },
    // 定额--level2-其他
    {
        path: '/quota/level2/others',
        component: Layout,
        redirect: '/quota/level2/others/index',
        children: [
            {
                path: 'index',
                name: 'others',
                component: () => import('@/views/business/energy/quota/level2/others/index')
            }
        ]
    },
    // 设备--level1-
    {
        path: '/device/level1',
        component: Layout,
        redirect: '/device/level1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/device/level1/index')
            }
        ]
    },
     // 能耗设备
     {
        path: '/device/level2/l1',
        component: Layout,
        redirect: '/device/level2/l1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/device/level2/l1/index')
            }
        ]
    },
      // 能耗设备
      {
        path: '/device/level2/l2',
        component: Layout,
        redirect: '/device/level2/l2/index',
        children: [
            {
                path: 'index',
                name: 'level2',
                component: () => import('@/views/business/energy/device/level2/l2/index')
            }
        ]
    },
      // 能耗设备
      {
        path: '/device/level2/l3',
        component: Layout,
        redirect: '/device/level2/l3/index',
        children: [
            {
                path: 'index',
                name: 'level3',
                component: () => import('@/views/business/energy/device/level2/l3/index')
            }
        ]
    },
      // 能耗设备
      {
        path: '/device/level2/l4',
        component: Layout,
        redirect: '/device/level2/l4/index',
        children: [
            {
                path: 'index',
                name: 'level4',
                component: () => import('@/views/business/energy/device/level2/l4/index')
            }
        ]
    },
    // 标准煤--level1-
    {
        path: '/coal/level1',
        component: Layout,
        redirect: '/coal/level1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/coal/level1/index')
            }
        ]
    },
    // 碳排放--level1-
    {
        path: '/carbon/level1',
        component: Layout,
        redirect: '/carbon/level1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/carbon/level1/index')
            }
        ]
    },
    // 绩效--level1-
    {
        path: '/performance/level1',
        component: Layout,
        redirect: '/performance/level1/index',
        children: [
            {
                path: 'index',
                name: 'level1',
                component: () => import('@/views/business/energy/performance/level1/index')
            }
        ]
    },
    //------------------------------------能耗---录入------------
     // 电力---暖通空调录入
     {
        path: '/infoinput/electric/aircondition',
        component: Layout,
        redirect: '/infoinput/electric/aircondition/index',
        children: [
            {
                path: 'index',
                name: 'infoinputaircondition',
                component: () => import('@/views/business/energy/infoinput/electric/aircondition/index')
            }
        ]
    },
     // 电力---照明插座录入
     {
        path: '/infoinput/electric/light',
        component: Layout,
        redirect: '/infoinput/electric/light/index',
        children: [
            {
                path: 'index',
                name: 'infoinputlight',
                component: () => import('@/views/business/energy/infoinput/electric/light/index')
            }
        ]
    },
     // 电力---动力设备录入
     {
        path: '/infoinput/electric/power',
        component: Layout,
        redirect: '/infoinput/electric/power/index',
        children: [
            {
                path: 'index',
                name: 'infoinputpower',
                component: () => import('@/views/business/energy/infoinput/electric/power/index')
            }
        ]
    },
     // 电力---特殊设备录入
     {
        path: '/infoinput/electric/special',
        component: Layout,
        redirect: '/infoinput/electric/special/index',
        children: [
            {
                path: 'index',
                name: 'infoinputspecial',
                component: () => import('@/views/business/energy/infoinput/electric/special/index')
            }
        ]
    },
     // 水---中水录入
     {
        path: '/infoinput/water/reclaimed',
        component: Layout,
        redirect: '/infoinput/water/reclaimed/index',
        children: [
            {
                path: 'index',
                name: 'infoinputreclaimed',
                component: () => import('@/views/business/energy/infoinput/water/reclaimed/index')
            }
        ]
    },
     // 水---自来水录入
     {
        path: '/infoinput/water/tap',
        component: Layout,
        redirect: '/infoinput/water/tap/index',
        children: [
            {
                path: 'index',
                name: 'infoinputtap',
                component: () => import('@/views/business/energy/infoinput/water/tap/index')
            }
        ]
    },
    // 热力录入
    {
        path: '/infoinput/hot',
        component: Layout,
        redirect: '/infoinput/hot/index',
        children: [
            {
                path: 'index',
                name: 'infoinputhot',
                component: () => import('@/views/business/energy/infoinput/hot/index')
            }
        ]
    },
     // 气录入
     {
        path: '/infoinput/gas',
        component: Layout,
        redirect: '/infoinput/gas/index',
        children: [
            {
                path: 'index',
                name: 'infoinputgas',
                component: () => import('@/views/business/energy/infoinput/gas/index')
            }
        ]
    },
    // 其他录入
    {
        path: '/infoinput/others',
        component: Layout,
        redirect: '/infoinput/others/index',
        children: [
            {
                path: 'index',
                name: 'infoinputothers',
                component: () => import('@/views/business/energy/infoinput/others/index')
            }
        ]
    },
     // 价格录入
     {
        path: '/infoinput/price',
        component: Layout,
        redirect: '/infoinput/price/index',
        children: [
            {
                path: 'index',
                name: 'infoinputprice',
                component: () => import('@/views/business/energy/infoinput/price/index')
            }
        ]
    },
     // 节能年度目标录入
     {
        path: '/infoinput/performanc/year',
        component: Layout,
        redirect: '/infoinput/performanc/year/index',
        children: [
            {
                path: 'index',
                name: 'infoinputperformanc',
                component: () => import('@/views/business/energy/infoinput/performanc/year/index')
            }
        ]
    },
     // 节能月度目标录入
     {
        path: '/infoinput/performanc/month',
        component: Layout,
        redirect: '/infoinput/performanc/month/index',
        children: [
            {
                path: 'index',
                name: 'infoinputperformanc',
                component: () => import('@/views/business/energy/infoinput/performanc/month/index')
            }
        ]
    },
     // 节能季度目标录入
     {
        path: '/infoinput/performanc/season',
        component: Layout,
        redirect: '/infoinput/performanc/season/index',
        children: [
            {
                path: 'index',
                name: 'infoinputperformanc',
                component: () => import('@/views/business/energy/infoinput/performanc/season/index')
            }
        ]
    },
     // 定额年度录入
     {
        path: '/infoinput/quota/year',
        component: Layout,
        redirect: '/infoinput/quota/year/index',
        children: [
            {
                path: 'index',
                name: 'infoinputquotayear',
                component: () => import('@/views/business/energy/infoinput/quota/year/index')
            }
        ]
    },
      // 定额季度录入
      {
        path: '/infoinput/quota/season',
        component: Layout,
        redirect: '/infoinput/quota/season/index',
        children: [
            {
                path: 'index',
                name: 'infoinputquota',
                component: () => import('@/views/business/energy/infoinput/quota/season/index')
            }
        ]
    },
      // 定额月度录入
      {
        path: '/infoinput/quota/month',
        component: Layout,
        redirect: '/infoinput/quota/month/index',
        children: [
            {
                path: 'index',
                name: 'infoinputquota',
                component: () => import('@/views/business/energy/infoinput/quota/month/index')
            }
        ]
    },
     // 能耗绩效标准录入
     {
        path: '/infoinput/performance',
        component: Layout,
        redirect: '/infoinput/performance/index',
        children: [
            {
                path: 'index',
                name: 'infoinputperformance',
                component: () => import('@/views/business/energy/infoinput/performance/index')
            }
        ]
    },
     // 能耗影响系数录入
     {
        path: '/infoinput/consumption',
        component: Layout,
        redirect: '/infoinput/consumption/index',
        children: [
            {
                path: 'index',
                name: 'infoinputconsumption',
                component: () => import('@/views/business/energy/infoinput/consumption/index')
            }
        ]
    },
      // 能耗影响系数原因录入
      {
        path: '/infoinput/consumption/influence',
        component: Layout,
        redirect: '/infoinput/consumption/influence/index',
        children: [
            {
                path: 'index',
                name: 'infoinputconsumption',
                component: () => import('@/views/business/energy/infoinput/consumption/influence/index')
            }
        ]
    },
     // 乾阳能耗首页
     {
    path: '/qyenergy/home',
     name: 'qyHome',
      // component: Layout,
      // redirect: '/infoinput/consumption/influence/index',
      // component: () => import('@/views/business/home/facilityHome/tenant/index')
       component: () => import('@/views/business/zg/index')
    //    children: [
    //     {
    //         path: 'index',
    //         name: 'qyHome',
    //         component: () => import('@/views/business/home/facilityHome/tenant/index')
    //     }

        //-------------------乌海----
    //     path: '/qyenergy/home',
    //     name: 'qyHome',
    //     component: Layout,
    //    // redirect: '/infoinput/consumption/influence/index',
    //    // component: () => import('@/views/business/home/facilityHome/tenant/index')
    //     //component: () => import('@/views/business/qy/index')
    //     children: [
    //      {
    //          path: 'index',
    //          name: 'qyHome',
    //          component: () => import('@/views/business/home/facilityHome/tenant/index')
    //      }

        //-------------------
   //]
   
    },
    {
       
    
            //-------------------刘家窑----
            path: '/iot/real/',
            name: 'notify',
            component: Layout,
            redirect: '/iot/real/alarm',
           // component: () => import('@/views/business/home/facilityHome/tenant/index')
            //component: () => import('@/views/business/qy/index')
            children: [
             {
                path: 'index',
                name: 'TenantNotify',
                 component: () => import('@/views/iori/notify/tenant/index')
             }
    
            //-------------------
       ]
       
    },
    // 刘家窑 -> 环境监测
    {
        path: '/environmental',
        component: Layout,
        redirect: '/environmental/monitoring',
        children: [
            {
                path: 'monitoring',
                component: () => import('@/views/business/base/environmental-monitoring')
            }
        ]
    }
]

export default businessRouter
